import type { ReactNode } from 'react';
import s from './Templates.module.css';

/** Dashboard template (IA §5.1): header, then a responsive grid of cards (ui/Grid). */
export function DashboardTemplate({ header, children }: { header: ReactNode; children: ReactNode }) {
  return (
    <div className={s.dashboard}>
      {header}
      {children}
    </div>
  );
}
